import { useEffect, useRef, useState } from "react";

const MonthDropdown = ({ selectedMonth, onSelect }) => {
	const [isDropdownOpen, setIsDropdownOpen] = useState(false);
	const chartRef = useRef(null);

	const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

	const handleSelectMonth = (month) => {
		onSelect(month);
		setIsDropdownOpen(false);
	};

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (chartRef.current && !chartRef.current.contains(event.target)) {
				setIsDropdownOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => document.removeEventListener("mousedown", handleClickOutside);
	}, []);

	return (
		<div className="relative" ref={chartRef}>
			<button
				id="dropdownDefaultButton"
				onClick={toggleDropdown}
				className="inline-flex min-h-[40px] items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-blue-gray px-3 font-medium text-light-white text-xs transition-all duration-200 hover:bg-opacity-40 focus:outline-none focus:ring-4 focus:ring-dark-blue sm:min-h-[44px] sm:px-4 sm:text-sm md:px-5 md:text-base"
				type="button"
			>
				{selectedMonth === "thisMonth" ? "This Month" : "Last Month"}
				<svg
					className="h-3 w-3 shrink-0 text-white sm:h-4 sm:w-4 md:h-4 md:w-4"
					aria-hidden="true"
					xmlns="http://www.w3.org/2000/svg"
					fill="none"
					viewBox="0 0 10 6"
				>
					<path
						stroke="currentColor"
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth="2"
						d="m1 1 4 4 4-4"
					/>
				</svg>
			</button>

			{isDropdownOpen && (
				<div
					id="dropdown"
					className="absolute left-0 z-10 mt-2 w-36 divide-y divide-gray-100 rounded-lg bg-dark-blue shadow"
				>
					<ul className="py-2 text-gray-200 text-sm" aria-labelledby="dropdownDefaultButton">
						<li>
							<button
								className="block w-full px-2 py-2 text-left hover:bg-blue-gray hover:text-white"
								onClick={() => handleSelectMonth("thisMonth")}
							>
								This Month
							</button>
						</li>
						<li>
							<button
								className="block w-full px-2 py-2 text-left hover:bg-blue-gray hover:text-white"
								onClick={() => handleSelectMonth("lastMonth")}
							>
								Last Month
							</button>
						</li>
					</ul>
				</div>
			)}
		</div>
	);
};

export default MonthDropdown;
